(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/loader/assets/javascripts/loader.js') >= 0) return;  svs.modules.push('/components/components/loader/assets/javascripts/loader.js'); 
var svs = svs || {};

(function(svs, Spinner) {
  'use strict';

  var oldLoader;

  svs.components = svs.components || {};

  svs.components.Loader = function(element, loaderOptions) {
    var defaultElSelector = '.js-loader-container';
    var defaultPlaceholderSelector = '.js-loader-placeholder';
    var el = null;
    var placeholderEl = null;
    var timeoutId = null;
    var SHOW_DELAY_MS = 200;
    var spinner = null;
    var spinnerOptions = {
      lines: 12, 
      length: 18, 
      width: 5, 
      radius: 12, 
      corners: 1, 
      rotate: 0, 
      direction: 1, 
      color: '#e1e1e5', 
      speed: 1, 
      trail: 60, 
      shadow: false, 
      hwaccel: true, 
      className: 'spinner', 
      zIndex: 2e9, 
      top: '50%', 
      left: '50%', 
      delayedShow: true
    };
    var options = {
      delayedShow: true
    }; 
    var sizes = {
      100: {
        radius: 2,
        length: 3,
        width: 2,
        lines: 8
      },
      200: {
        radius: 4,
        length: 6,
        width: 2,
        lines: 10
      },
      300: {
        radius: 8,
        length: 12,
        width: 4,
        lines: 12
      }
    };

    $.extend(options, loaderOptions);

    return {
      hide: function(keepElement) {
        if (timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = null;
        }

        if (el && !keepElement) {
          el.addClass('hide');
        }

        if (spinner) {
          spinner.stop();
        }
        return this;
      },

      show: function(size, theme) {
        var isFullscreenLoader = false;

        if (!element) {
          el = $(defaultElSelector);

          if (el.length === 0) {
            $('body').append(svs.components.loader.templates.loader());
            el = $(defaultElSelector);
          }

          isFullscreenLoader = true;
        } else if (typeof element === 'string') {
          el = $(element);
        } else {
          el = element;
        }

        if (spinner) {
          spinner.stop();
        }

        var currentSize = sizes['300'];

        if (size) {
          currentSize = sizes[size];
        }

        spinnerOptions.radius = currentSize.radius;
        spinnerOptions.length = currentSize.length;
        spinnerOptions.width = currentSize.width;
        spinnerOptions.lines = currentSize.lines;

        if (theme && theme === 'inverted') {
          spinnerOptions.color = '#323233';
        } else {
          spinnerOptions.color = '#e1e1e5';
        }

        var spin = function() {
          if (timeoutId || !options.delayedShow) {
            timeoutId = null;
            el.removeClass('hide');

            placeholderEl = el;

            if (isFullscreenLoader) {
              placeholderEl = el.find(defaultPlaceholderSelector);
            }

            spinner = new Spinner(spinnerOptions).spin(placeholderEl[0]);
          }
        };

        if (options.delayedShow) {
          timeoutId = setTimeout(spin, SHOW_DELAY_MS);
        } else {
          spin();
        }
        return this;
      }
    };
  };

  if (svs.components.loader && svs.components.loader.templates) {
    oldLoader = svs.components.loader;
  }

  svs.components.loader = new svs.components.Loader();

  if (oldLoader) {
    svs.components.loader.templates = oldLoader.templates;
  }

  svs.events.subscribe('/loader/show', function() {
    svs.components.loader.show();
  });

  svs.events.subscribe('/loader/hide', function() {
    svs.components.loader.hide();
  });
})(svs, Spinner);

 })(window);